import styled from "styled-components";
import { media } from "../../theme/theme";
import { V3HeadlineH4 } from "../Typography";
import { V3ProfileHeroColorVariants } from "../ProfileHero/V3ProfileHero.types";

export const PAHWrapper = styled.div<{ $showShadow: boolean, $nonSticky?: boolean }>`
    position: ${({ $nonSticky }) => $nonSticky ? "relative" : "sticky"};
    top: 0;
    background: ${({ $nonSticky }) => $nonSticky ? undefined : "white"};
    z-index: 2;
    box-shadow: ${({ $showShadow }) => $showShadow ? "0px 6px 12px rgba(0, 0, 0, 0.05);" : null};

    @media print {
        display: none;
    }
`;

export const PAHContainer = styled.div`
    max-width: 1300px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
`;

export const PAHLeftSide = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 12px;
        }
    }
`;

export const PAHRightSide = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            display: none;

            ${media.custom(900)} {
                display: block;
            }
        }
    }
`;

export const V3PublicHeaderAuthorName = styled(V3HeadlineH4) <{ $colorVariant: V3ProfileHeroColorVariants }>`
    color:  ${({ $colorVariant, theme }) => $colorVariant === V3ProfileHeroColorVariants.light ? "white" : theme.v3.colors.ink};
`;